import React, { useContext, useState, useEffect, useCallback } from "react";
import {
  Card,
  Spinner,
  Table,
  Button,
  Label,
  TextInput,
  Modal,
  Dropdown,
  Pagination,
  Select,
} from "flowbite-react";
import { Store } from "../context/store";
import { IoMdArrowBack, IoMdAddCircleOutline, IoMdSend } from "react-icons/io";
import { useNavigate, useSearchParams } from "react-router-dom";
import apiRequest from "../utils/apiRequest";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { FiFilter } from "react-icons/fi";
import { AiOutlineClear } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import CustomToast from "../components/Toast";
import { useAllPermissions } from "../utils/usePermission";
import { confirmDialog } from "../components/ConfirmDialog";
import DashboardLayout from "../components/layout/DashboardLayout";

function Opex() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  let [user] = store.loggedInUser;
  let [opexArray, setOpexArray] = store.opexArray;
  let [, setLoading] = useState(false);
  let [editCategory, setEditCategory] = useState(false);
  let [editIndex, setEditIndex] = useState(null);
  const [secondCard, setSecondCard] = useState(false);
  const [invoiceBody, setInvoiceBody] = useState({
    purpose: [
      {
        item: "",
        price: "",
        quantity: "",
        category: "",
      },
    ],
    payee: "",
    accountNumber: "",
    bank: "",
    paymentType: "",
  });
  const navigate = useNavigate();
  let [msg, setMsg] = useState("");
  const [openModalOut, setOpenModalOut] = useState(false);
  let [opex, setOpex] = useState([]);
  let [budget, setBudget] = useState([]);
  let [loading1] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalPages, setTotalPages] = useState(1);
  let [status, setStatus] = useState("pending");
  const page = parseInt(searchParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(page);
  const [openModal, setOpenModal] = useState(false);
  const [error, setError] = useState("");
  let [singleOpex, setSingleOpex] = useState({});
  let [loading2, setLoading2] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateField, setDateField] = useState("valueDate");

  const { canWriteExpenditure, canReadExpenditure } = useAllPermissions();

  const loadBudget = useCallback(async () => {
    try {
      let token = localStorage.getItem("royal-token");
      const currentYear = new Date().getFullYear();
      const url = `${baseUrl}/budget-expenses?year=${currentYear}`;
      const { data } = await apiRequest(url, "GET", null, token);
      setBudget(data);
    } catch (error) {
      const unauthorizedErrors = [
        "Access Denied: Invalid or expired token. Please login again",
        "Access Denied: Please log in.",
        "Access Denied: Invalid Token.",
        "Access Denied: Invalid or expired token.",
        "Access Denied: Invalid or Expired Token.",
        "Access Denied: No token provided.",
      ];
      if (unauthorizedErrors.includes(error.message)) {
        setMsg("Session Expired!");
        setOpenModalOut(true);
        localStorage.removeItem("royal-token");
      } else {
        console.log(error);
      }
    }
  }, [baseUrl]);

  useEffect(() => {
    loadBudget();
  }, [loadBudget]);

  function onCloseModal() {
    setOpenModal(false);
  }

  const onPageChange = (page) => {
    setSearchParams({ page: page });
    setCurrentPage(page);
  };

  const loadOpEx = useCallback(async () => {
    setLoading(true);
    try {
      let token = localStorage.getItem("royal-token");
      const params = new URLSearchParams({
        type: "OpEx",
        status,
        page,
      });
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      if (startDate || endDate) params.append("dateField", dateField);

      const url = `${baseUrl}/expenditures?${params.toString()}`;
      const { data } = await apiRequest(url, "GET", null, token);
      setOpex(data.expenditures);
      setTotalPages(data.totalPages);
    } catch (error) {
      const unauthorizedErrors = [
        "Access Denied: Invalid or expired token. Please login again",
        "Access Denied: Please log in.",
        "Access Denied: Invalid Token.",
        "Access Denied: Invalid or expired token.",
        "Access Denied: Invalid or Expired Token.",
        "Access Denied: No token provided.",
      ];
      if (unauthorizedErrors.includes(error.message)) {
        setMsg("Session Expired!");
        setOpenModalOut(true);
        localStorage.removeItem("royal-token");
      } else {
        console.log(error);
      }
    }
  }, [page, status, baseUrl, startDate, endDate, dateField]);

  useEffect(() => {
    Promise.all([loadOpEx()])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [loadOpEx]);

  const pushToInvoice = (e) => {
    if (
      !e.purpose?.[0]?.item ||
      !e.purpose?.[0]?.price ||
      !e.purpose?.[0]?.quantity ||
      !e.payee ||
      !e.paymentType
    ) {
      setError("Please fill all fields !!!");
      return;
    }

    if (!/^\d{10}$/.test(e.accountNumber || "")) {
      setError("Account number must be exactly 10 digits.");
      return;
    }

    if (e.purpose?.[0]?.category) {
      const matchedBudgetItem = budget.find(
        (budgetItem) => budgetItem.title === e.purpose?.[0]?.category,
      );

      if (matchedBudgetItem) {
        const itemTotal = e.purpose?.[0]?.price * e.purpose?.[0]?.quantity;
        if (matchedBudgetItem.amountLeft - itemTotal < 0) {
          setToastMessage(
            `Warning: Adding this item will exceed the remaining budget for "${e.purpose?.[0]?.category}".`,
          );
          setToastOpen(true);
          setTimeout(() => {
            setToastOpen(false);
          }, 3000);
        }
      }
    }

    opexArray.rows.push(e);
    setError("");
    setInvoiceBody({
      purpose: [
        {
          item: "",
          price: "",
          quantity: "",
          category: "",
        },
      ],
      payee: "",
      accountNumber: "",
      bank: "",
      paymentType: "",
    });
  };

  const createOpEx = async () => {
    if (opexArray.rows.length === 0) {
      setError("At least one item must be added to the list.");
      return;
    }

    await confirmDialog(
      "Are you sure you want to create these OpEx Request(s)?",
      {
        title: "Create OpEx Requests",
        confirmText: "Yes, create",
        color: "success",
        loadingText: "Creating...",
        onConfirm: async () => {
          setLoading(true); // Set loading to true
          try {
            let token = localStorage.getItem("royal-token");
            const url = `${baseUrl}/expenditure`;

            for (const item of opexArray.rows) {
              const body = {
                type: "OpEx",
                purpose: item.purpose,
                payee: item.payee,
                bank: item.bank || "N/A",
                accountNumber: item.accountNumber || "N/A",
                paymentType: item.paymentType,
                valueDate: item.valueDate,
              }; // Send each item as a single purpose array
              await apiRequest(url, "POST", body, token);
            }

            setOpexArray({ rows: [] });
            setInvoiceBody({});
            loadOpEx(); // Reload all OpEx items
            loadBudget(); // Reload budget
            setError("OpEx request(s) created successfully!");
          } catch (error) {
            setError(error.message);
          } finally {
            setLoading(false); // Ensure loading is set to false
          }
        },
      },
    );
  };

  const updateOpEx = async () => {
    let id = singleOpex.id;
    if (opexArray.rows.length === 0) {
      setError("At least one item must be added to the list.");
      return;
    }

    let body = {
      type: "OpEx",
      purpose: [
        {
          item: opexArray.rows[0].purpose[0].item,
          price: opexArray.rows[0].purpose[0].price,
          quantity: opexArray.rows[0].purpose[0].quantity,
          category: opexArray.rows[0].purpose[0].category || "",
        },
      ],
      payee: opexArray.rows[0].payee || "",
      bank: opexArray.rows[0].bank !== "N/A" ? opexArray.rows[0].bank : "",
      accountNumber: opexArray.rows[0].accountNumber || "",
      paymentType: opexArray.rows[0].paymentType || "",
      valueDate: opexArray.rows[0].valueDate || "",
    };
    await confirmDialog(
      "Are you sure you want to update this OpEx Request?",
      {
        title: "Update OpEx Request",
        confirmText: "Yes, update",
        color: "warning",
        loadingText: "Updating...",
        onConfirm: async () => {
          try {
            let token = localStorage.getItem("royal-token");
            const url = `${baseUrl}/expenditure/${id}`;
            let { message } = await apiRequest(url, "PUT", body, token);
            setError(message);
            setOpexArray({ rows: [] });
            setInvoiceBody({});
            loadOpEx();
            setLoading(false);
            setSingleOpex({});
            setSecondCard(false);
          } catch (error) {
            setError(error.message);
          } finally {
            setError("");
          }
        },
      },
    );
  };

  const updateValueDate = async (id, newValueDate, loadOpEx, setError) => {
    await confirmDialog(
      "Are you sure you want to update the Value Date?",
      {
        title: "Update Value Date",
        confirmText: "Yes, update",
        color: "warning",
        loadingText: "Updating...",
        onConfirm: async () => {
          try {
            const token = localStorage.getItem("royal-token");
            const url = `${baseUrl}/expenditure/${id}/value-date`;
            const body = { valueDate: newValueDate };

            const { message, data } = await apiRequest(url, "PUT", body, token);

            setError(message);
            setSingleOpex({ ...singleOpex, valueDate: data.valueDate });
          } catch (err) {
            setError(err.message || "Something went wrong.");
          }
        },
      },
    );
  };

  let displayOnModal = (e) => {
    setSingleOpex(e);
    setOpenModal(true);
  };

  let logOut = () => {
    navigate("/");
  };

  const changeOpExStatus = async (a, b) => {
    await confirmDialog(
      `Are you sure you want to ${b === "cancelled" ? "Cancel" : "Approve"}?`,
      {
        title: b === "cancelled" ? "Cancel OpEx" : "Approve OpEx",
        confirmText: b === "cancelled" ? "Yes, cancel" : "Yes, approve",
        color: b === "cancelled" ? "failure" : "success",
        loadingText: b === "cancelled" ? "Cancelling..." : "Approving...",
        onConfirm: async () => {
          setLoading2(true);
          try {
            let token = localStorage.getItem("royal-token");
            const url = `${baseUrl}/authorize/expenditure/${a}`;
            const { data, message } = await apiRequest(
              url,
              "PUT",
              { status: b },
              token,
            );
            alert(message);
            setSingleOpex(data);
            setOpex((prevMessages) =>
              prevMessages.map((singleOpex) =>
                singleOpex.id === data.id ? data : singleOpex,
              ),
            );
            setLoading2(false);
          } catch (error) {
            alert(error.message);
            setLoading2(false);
          }
        },
      },
    );
  };

  const handleShowEdit = () => {
    setSecondCard(true);
    setOpexArray({
      rows: [
        {
          purpose: [singleOpex.purpose[0]],
          accountNumber: singleOpex.accountNumber,
          bank: singleOpex.bank,
          paymentType: singleOpex.paymentType,
          payee: singleOpex.payee,
          valueDate: singleOpex.valueDate,
        },
      ],
    });
    setOpenModal(false);
  };

  const handleEdit = (a, b) => {
    setEditCategory(true);
    setInvoiceBody({
      purpose: [
        {
          item: a.purpose[0].item,
          price: a.purpose[0].price,
          quantity: a.purpose[0].quantity,
          category: a.purpose[0].category || "",
        },
      ],
      payee: a.payee || "",
      accountNumber: a.accountNumber || "",
      bank: a.bank !== "N/A" ? a.bank : "",
      paymentType: a.paymentType || "",
      valueDate: a.valueDate || "",
    });
    setEditIndex(b);
  };

  const pushUpdateToInvoice = (e) => {
    if (
      !e.purpose?.[0]?.item ||
      !e.purpose?.[0]?.price ||
      !e.purpose?.[0]?.quantity ||
      !e.payee ||
      !e.paymentType
    ) {
      setError("Please fill all fields !!!");
      return;
    }

    if (!/^\d{10}$/.test(e.accountNumber || "")) {
      setError("Account number must be exactly 10 digits.");
      return;
    }

    if (e.purpose?.[0]?.category) {
      const matchedBudgetItem = budget.find(
        (budgetItem) => budgetItem.title === e.purpose?.[0]?.category,
      );

      if (matchedBudgetItem) {
        const itemTotal = e.purpose?.[0]?.price * e.purpose?.[0]?.quantity;
        if (matchedBudgetItem.amountLeft - itemTotal < 0) {
          setToastMessage(
            `Warning: Adding this item will exceed the remaining budget for "${e.purpose?.[0]?.category}".`,
          );
          setToastOpen(true);
          setTimeout(() => {
            setToastOpen(false);
          }, 3000);
        }
      }
    }

    opexArray.rows[editIndex] = e;
    setError("");
    setInvoiceBody({
      purpose: [
        {
          item: "",
          price: "",
          quantity: "",
          category: "",
        },
      ],
      payee: "",
      accountNumber: "",
      bank: "",
      paymentType: "",
    });
    setEditIndex(null);
    setEditCategory(false);
  };

  const toTwoDecimal = (value) => {
    if (value === "") return "";
    const parsed = Number.parseFloat(value);
    if (Number.isNaN(parsed)) return "";
    return Math.round(parsed * 100) / 100;
  };

  return (
    <>
      <title>Opex</title>
      <meta
        name="description"
        content="Opex Page to the Royalmines Property Office"
      />

      <DashboardLayout active="opex">
            {!secondCard && (
              <div
                className="col-span-12 md:col-span-4 mx-2"
                data-aos="flip-up"
              >
                <div className="mb-4">
                  <h5 className="text-xl font-bold leading-none text-gray-900 dark:text-white">
                    Operational Expenditures
                  </h5>
                  <div className="flex flex-wrap gap-2 mt-5 justify-end">
                    <Button
                      color="success"
                      onClick={() => {
                        setSecondCard(true);
                        setSingleOpex({});
                        setEditIndex(null);
                        setEditCategory(false);
                      }}
                      disabled={!canWriteExpenditure}
                    >
                      <IoMdAddCircleOutline className="me-2" />
                      New OpEx
                    </Button>

                    <Dropdown
                      label={
                        <Button className="bg-#6eb5ff">
                          <FiFilter className="me-2" /> Filter By
                        </Button>
                      }
                      dismissOnClick={true}
                      inline
                    >
                      <Dropdown.Item
                        className={status === "" ? "active-dropdown" : ""}
                        onClick={() => {
                          setSearchParams({ page: 1 });
                          setStatus("");
                          setCurrentPage(1);
                        }}
                      >
                        All
                      </Dropdown.Item>
                      <Dropdown.Item
                        className={
                          status === "pending" ? "active-dropdown z-10" : ""
                        }
                        onClick={() => {
                          setSearchParams({ page: 1 });
                          setStatus("pending");
                          setCurrentPage(1);
                        }}
                      >
                        Pending
                      </Dropdown.Item>
                      <Dropdown.Item
                        className={
                          status === "approved" ? "active-dropdown" : ""
                        }
                        onClick={() => {
                          setSearchParams({ page: 1 });
                          setStatus("approved");
                          setCurrentPage(1);
                        }}
                      >
                        Approved
                      </Dropdown.Item>
                      <Dropdown.Item
                        className={
                          status === "cancelled" ? "active-dropdown" : ""
                        }
                        onClick={() => {
                          setSearchParams({ page: 1 });
                          setStatus("cancelled");
                          setCurrentPage(1);
                        }}
                      >
                        Cancelled
                      </Dropdown.Item>
                    </Dropdown>
                  </div>
                  <Card className="rounded-xl my-4">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <div>
                        <div className="mb-2 block">
                          <Label htmlFor="opexStartDate" value="Start Date" />
                        </div>
                        <TextInput
                          id="opexStartDate"
                          type="date"
                          value={startDate}
                          onChange={(e) => {
                            setSearchParams({ page: 1 });
                            setCurrentPage(1);
                            setStartDate(e.target.value);
                          }}
                        />
                      </div>
                      <div>
                        <div className="mb-2 block">
                          <Label htmlFor="opexEndDate" value="End Date" />
                        </div>
                        <TextInput
                          id="opexEndDate"
                          type="date"
                          value={endDate}
                          onChange={(e) => {
                            setSearchParams({ page: 1 });
                            setCurrentPage(1);
                            setEndDate(e.target.value);
                          }}
                        />
                      </div>
                      <div>
                        <div className="mb-2 block">
                          <Label htmlFor="opexDateField" value="Date Field" />
                        </div>
                        <Select
                          id="opexDateField"
                          value={dateField}
                          onChange={(e) => {
                            setSearchParams({ page: 1 });
                            setCurrentPage(1);
                            setDateField(e.target.value);
                          }}
                        >
                          <option value="valueDate">Value Date</option>
                          <option value="createdAt">Transaction Date</option>
                        </Select>
                      </div>
                      <div className="flex items-end">
                        <Button
                          color="light"
                          className="w-full"
                          onClick={() => {
                            setSearchParams({ page: 1 });
                            setCurrentPage(1);
                            setStartDate("");
                            setEndDate("");
                            setDateField("valueDate");
                          }}
                        >
                          Clear Date Filters
                        </Button>
                      </div>
                    </div>
                  </Card>
                </div>
                {!loading1 ? (
                  <>
                    <Card className="rounded-xl my-4">
                      <div className="overflow-x-auto overflow-y-scroll h-[50vh] scrollbar-always-visible">
                        <Table
                          striped
                          hoverable
                          className="w-full text-sm text-left text-gray-500 uppercase"
                        >
                          <thead className="bg-gray-100 sticky top-0 z-5">
                            <tr>
                              <th className="px-6 py-3">Initiated By</th>
                              <th className="px-6 py-3">Transaction Date</th>
                              <th className="px-6 py-3">Value Date</th>
                              <th className="px-6 py-3">Purpose</th>
                              <th className="px-6 py-3">Status</th>
                              <th className="px-6 py-3">Total</th>
                              <th className="px-6 py-3">
                                <span className="sr-only">Edit</span>
                              </th>
                            </tr>
                          </thead>

                          <Table.Body className="divide-y">
                            {opex.length === 0 ? (
                              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <Table.Cell
                                  colSpan={5}
                                  className="text-center py-10"
                                >
                                  No {status} opex.
                                </Table.Cell>
                              </Table.Row>
                            ) : (
                              opex.map((e, i) => (
                                <Table.Row
                                  key={i}
                                  className={`bg-white dark:border-gray-700 dark:bg-gray-800 ${
                                    e.status === "approved"
                                      ? "read-msgs"
                                      : e.status === "cancelled"
                                        ? "reads-msgs"
                                        : ""
                                  }`}
                                >
                                  <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white align-top">
                                    {e.requestedBy.firstName}{" "}
                                    {e.requestedBy.lastName}
                                  </Table.Cell>
                                  <Table.Cell className="align-top">
                                    {formatDate(e?.createdAt)}
                                  </Table.Cell>
                                  <Table.Cell className="align-top">
                                    {formatDate(e?.valueDate)}
                                  </Table.Cell>
                                  <Table.Cell className="text-ellipsis align-top">
                                    {e.purpose.map((a, b) => (
                                      <div key={b} className="mb-1">
                                        <p>Item: {a.item}</p>
                                        <p>
                                          Amount: {a.price.toLocaleString()}
                                        </p>
                                        <p>Qty: {a.quantity}</p>
                                        <p>Category: {a.category || "N/A"}</p>
                                        {e.purpose.length > 1 && <hr />}
                                      </div>
                                    ))}
                                  </Table.Cell>
                                  <Table.Cell className="text-ellipsis  align-top">
                                    {e.status}
                                  </Table.Cell>
                                  <Table.Cell className="text-ellipsis align-top">
                                    &#8358; {e.total.toLocaleString()}
                                  </Table.Cell>
                                  <Table.Cell className="align-top">
                                    <p
                                      className="font-medium text-cyan-600 hover:underline dark:text-cyan-500"
                                      onClick={() => {
                                        if (canReadExpenditure) {
                                          displayOnModal(e);
                                        }
                                      }}
                                      style={{
                                        textDecoration: "none",
                                        cursor: canReadExpenditure
                                          ? "pointer"
                                          : "not-allowed",
                                      }}
                                    >
                                      View
                                    </p>
                                  </Table.Cell>
                                </Table.Row>
                              ))
                            )}
                          </Table.Body>
                        </Table>
                      </div>
                    </Card>

                    {opex?.length > 0 && (
                      <div className="flex overflow-x-auto sm:justify-center mb-5">
                        <Pagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={onPageChange}
                          showIcons
                          previousLabel=""
                          nextLabel=""
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex justify-center items-center h-[100%]">
                    <Spinner
                      style={{ color: "#0078e7" }}
                      aria-label="info spinner example"
                      size="xl"
                    />
                  </div>
                )}
              </div>
            )}

            {/* add items to opex */}
            {secondCard && (
              <div
                className="col-span-12 md:col-span-4 mx-2"
                data-aos="slide-right"
              >
                <h5 className="text-xl font-bold leading-none text-gray-900 dark:text-white">
                  Operational Expenditures
                </h5>
                <div className="flex flex-wrap gap-2 mt-5 justify-between">
                  <Button
                    onClick={() => {
                      setSecondCard(false);
                      setError("");
                      setOpexArray({ rows: [] });
                      setEditIndex(null);
                      setEditCategory(false);
                      setInvoiceBody({
                        purpose: [
                          {
                            item: "",
                            price: "",
                            quantity: "",
                            category: "",
                          },
                        ],
                        payee: "",
                        accountNumber: "",
                        bank: "",
                        paymentType: "",
                      });
                    }}
                    className="bg-#6eb5ff"
                  >
                    <IoMdArrowBack className="me-2" />
                    Go Back
                  </Button>
                  {!singleOpex?.id ? (
                    <Button className="bg-#6eb5ff" onClick={() => createOpEx()}>
                      Submit
                      <IoMdSend className="ms-2" />
                    </Button>
                  ) : (
                    <Button className="bg-#6eb5ff" onClick={() => updateOpEx()}>
                      Update
                      <IoMdSend className="ms-2" />
                    </Button>
                  )}
                </div>

                <p className="text-red-600 text-center my-3 font-bold">
                  {error}
                </p>
                <Card className="w-full md:w-1/2 mx-auto">
                  <div className="flex flex-col gap-4">
                    {/* item */}
                    <div>
                      <div className="mb-2">
                        <div className="mb-2 block">
                          <Label htmlFor="item1" value="Item" />
                        </div>
                        <TextInput
                          id="item1"
                          type="text"
                          placeholder="Enter item"
                          // value={invoiceBody.item || invoiceBody.purpose?.[0].item}
                          value={invoiceBody.purpose?.[0]?.item || ""}
                          onChange={(e) =>
                            setInvoiceBody({
                              ...invoiceBody,
                              purpose: [
                                {
                                  ...invoiceBody.purpose?.[0],
                                  item: e.target.value,
                                },
                              ],
                            })
                          }
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-4 mb-2">
                        <div className="col-span-1">
                          <div className="mb-2 block">
                            <Label htmlFor="Rate1" value="Amount" />
                          </div>
                          <TextInput
                            id="Rate1"
                            type="number"
                            step="0.01"
                            placeholder="Enter Amount"
                            min={0}
                            value={invoiceBody.purpose?.[0]?.price || ""}
                            onChange={(e) =>
                              setInvoiceBody({
                                ...invoiceBody,
                                purpose: [
                                  {
                                    ...invoiceBody.purpose?.[0],
                                    price: toTwoDecimal(e.target.value),
                                  },
                                ],
                              })
                            }
                          />
                        </div>

                        <div className="col-span-1">
                          <div className="mb-2 block">
                            <Label htmlFor="Amount1" value="Quantity" />
                          </div>
                          <TextInput
                            id="Amount1"
                            type="number"
                            step="0.01"
                            placeholder="Enter Quantity"
                            min={0}
                            value={invoiceBody.purpose?.[0]?.quantity}
                            onChange={(e) =>
                              setInvoiceBody({
                                ...invoiceBody,
                                purpose: [
                                  {
                                    ...invoiceBody.purpose?.[0],
                                    quantity: toTwoDecimal(e.target.value),
                                  },
                                ],
                              })
                            }
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <Label htmlFor="category" value="Category (optional)" />
                        <Select
                          id="category"
                          value={invoiceBody.purpose?.[0]?.category || ""}
                          onChange={(e) =>
                            setInvoiceBody({
                              ...invoiceBody,
                              purpose: [
                                {
                                  ...invoiceBody.purpose[0],
                                  category: e.target.value,
                                },
                              ],
                            })
                          }
                          disabled={editCategory}
                        >
                          <option value="">None</option>
                          {budget.map((e, i) => (
                            <option key={e.id} value={e.title}>
                              {e.title}
                            </option>
                          ))}
                        </Select>
                      </div>

                      <div className="my-4 w-full">
                        <div className="mb-2 block">
                          <Label htmlFor="valueDate" value="Value Date" />
                        </div>
                        <TextInput
                          id="valueDate"
                          type="date"
                          value={toDateInputValue(invoiceBody.valueDate)}
                          onChange={(e) =>
                            setInvoiceBody({
                              ...invoiceBody,
                              valueDate: e.target.value,
                            })
                          }
                          color="blue"
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-4 mb-2">
                        {/* Payee */}
                        <div className="col-span-1">
                          <div className="mb-2 block">
                            <Label htmlFor="Payee" value="Payee" />
                          </div>
                          <TextInput
                            id="Payee"
                            type="text"
                            placeholder="Enter Payee Name"
                            value={invoiceBody.payee}
                            onChange={(e) =>
                              setInvoiceBody({
                                ...invoiceBody,
                                payee: e.target.value,
                              })
                            }
                          />
                        </div>

                        {/* Bank */}
                        <div className="col-span-1">
                          <div className="mb-2 block">
                            <Label htmlFor="Bank" value="Bank" />
                          </div>
                          <TextInput
                            id="Bank"
                            type="text"
                            placeholder="Enter Bank Name"
                            value={invoiceBody.bank}
                            onChange={(e) =>
                              setInvoiceBody({
                                ...invoiceBody,
                                bank: e.target.value,
                              })
                            }
                          />
                        </div>

                        {/* Account Number */}
                        <div className="col-span-1">
                          <div className="mb-2 block">
                            <Label
                              htmlFor="AccountNumber"
                              value="Account Number"
                            />
                          </div>
                          <TextInput
                            id="AccountNumber"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]{10}"
                            maxLength={10}
                            placeholder="Enter Account Number"
                            value={invoiceBody.accountNumber}
                            onChange={(e) =>
                              setInvoiceBody({
                                ...invoiceBody,
                                accountNumber: e.target.value
                                  .replace(/\D/g, "")
                                  .slice(0, 10),
                              })
                            }
                          />
                        </div>

                        {/* Payment Type */}
                        <div className="col-span-1">
                          <div className="mb-2 block">
                            <Label htmlFor="PaymentType" value="Payment Type" />
                          </div>
                          <select
                            id="PaymentType"
                            className="w-full border border-gray-300 rounded-lg p-2 text-sm"
                            value={invoiceBody.paymentType}
                            onChange={(e) =>
                              setInvoiceBody({
                                ...invoiceBody,
                                paymentType: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Payment Type</option>
                            <option value="Transfer">Transfer</option>
                            <option value="Cash">Cash</option>
                            <option value="POS">POS</option>
                            <option value="Cheque">Cheque</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    {editIndex === null ? (
                      <Button
                        type="button"
                        onClick={() => pushToInvoice(invoiceBody)}
                        className="bg-#6eb5ff"
                      >
                        Add to List
                      </Button>
                    ) : (
                      <Button
                        type="button"
                        onClick={() => pushUpdateToInvoice(invoiceBody)}
                        className="bg-#6eb5ff"
                      >
                        Update List
                      </Button>
                    )}
                  </div>
                </Card>
              </div>
            )}

            <>
              {secondCard && (
                <>
                  <div className="flex flex-wrap gap-2 mt-5 justify-end">
                    <Button
                      onClick={() => {
                        setOpexArray({ title: "", rows: [] });
                        setError("");
                      }}
                      className="bg-#6eb5ff"
                    >
                      Clear
                      <AiOutlineClear className="ms-2" />
                    </Button>
                  </div>
                  <Card className="rounded-xl my-4">
                    <div className="">
                      <div className="overflow-x-auto">
                        <Table className="border-2 border-black text-xs">
                          <Table.Head>
                            <Table.HeadCell colSpan={4}>Item</Table.HeadCell>
                            <Table.HeadCell colSpan={1}>Amount</Table.HeadCell>
                            <Table.HeadCell colSpan={1}>
                              Quantity
                            </Table.HeadCell>
                            <Table.HeadCell colSpan={1}>Total</Table.HeadCell>
                            <Table.HeadCell colSpan={1}>Payee</Table.HeadCell>
                            <Table.HeadCell colSpan={1}>
                              Payment Type
                            </Table.HeadCell>
                            <Table.HeadCell colSpan={1}>Edit</Table.HeadCell>
                          </Table.Head>
                          {opexArray?.rows?.map((e, i) => {
                            return (
                              <Table.Body className="divide-y divide-x text-black">
                                <Table.Row>
                                  <Table.Cell
                                    className="whitespace-nowrap text-ellipsis"
                                    colSpan={4}
                                  >
                                    {e.purpose?.[0].item}
                                  </Table.Cell>
                                  <Table.Cell colSpan={1}>
                                    {e.purpose?.[0].price}
                                  </Table.Cell>
                                  <Table.Cell colSpan={1}>
                                    {e.purpose?.[0].quantity}
                                  </Table.Cell>
                                  <Table.Cell colSpan={1}>
                                    {(
                                      e.purpose?.[0].quantity *
                                      e.purpose?.[0].price
                                    ).toLocaleString()}
                                  </Table.Cell>
                                  <Table.Cell colSpan={1}>{e.payee}</Table.Cell>
                                  <Table.Cell colSpan={1}>
                                    {e.paymentType}
                                  </Table.Cell>
                                  <Table.Cell
                                    onClick={() => handleEdit(e, i)}
                                    colSpan={1}
                                  >
                                    <FiEdit
                                      style={{ cursor: "pointer" }}
                                      color="#6db4ff"
                                    />
                                  </Table.Cell>
                                </Table.Row>
                              </Table.Body>
                            );
                          })}
                        </Table>
                      </div>
                    </div>
                  </Card>
                </>
              )}
            </>
            {/* )} */}

      {/* modal for singleOpex */}
      <Modal
        dismissible
        show={openModal}
        size="md"
        onClose={onCloseModal}
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900 dark:text-white">
              <strong>Initiated By: </strong>
              {singleOpex?.requestedBy?.firstName}{" "}
              {singleOpex?.requestedBy?.lastName}
            </h3>
            <div>
              <h4>
                <strong>Total: &#8358; </strong>
                {singleOpex?.total?.toLocaleString()}
              </h4>
            </div>
            <div>
              <h4>
                <strong>Payee: </strong>
                {singleOpex?.payee}
              </h4>
            </div>
            <div>
              <h4>
                <strong>Payment Type: </strong>
                {singleOpex?.paymentType}
              </h4>
            </div>
            <div>
              <h4>
                <strong>Bank: </strong>
                {singleOpex?.bank || "N/A"}
              </h4>
            </div>
            <div>
              <h4>
                <strong>Account Number: </strong>
                {singleOpex?.accountNumber || "N/A"}
              </h4>
            </div>
            <div>
              <h4>
                <strong>Transaction Date: </strong>
                {formatDate(singleOpex?.createdAt)}
              </h4>
            </div>
            <div>
              <h4>
                <strong>Value Date: </strong>
                {formatDate(singleOpex?.valueDate)}
              </h4>
            </div>
            <div>
              <h4>
                <strong>Status: </strong> {singleOpex?.status}
              </h4>
            </div>
            {singleOpex?.authorizedBy && (
              <div>
                <h4>
                  <strong>Authorized By: </strong>
                  {singleOpex?.authorizedBy?.firstName}{" "}
                  {singleOpex?.authorizedBy?.lastName}
                </h4>
              </div>
            )}
            {singleOpex?.authorizedBy && (
              <div>
                <h4>
                  <strong>Authorized Date: </strong>
                  {formatDate(singleOpex?.authorizedDate)}
                </h4>
              </div>
            )}

            <div className="w-full flex justify-center gap-3">
              {singleOpex?.status === "pending" && (
                <Button
                  color="failure"
                  onClick={() => changeOpExStatus(singleOpex.id, "cancelled")}
                  disabled={loading2}
                >
                  Cancel
                </Button>
              )}
              {singleOpex?.status === "pending" && (
                <Button
                  color="success"
                  onClick={() => changeOpExStatus(singleOpex.id, "approved")}
                  disabled={loading2}
                >
                  Approve
                </Button>
              )}

              {singleOpex?.status === "pending" &&
                user.id === singleOpex.requestedBy.id && (
                  <Button
                    color="warning"
                    onClick={handleShowEdit}
                    className="bg-blue-500"
                  >
                    Edit
                  </Button>
                )}

              {singleOpex?.status === "approved" &&
                user.id === singleOpex.requestedBy.id && (
                  <div className="my-4 w-full">
                    <div className="mb-2 block">
                      <Label htmlFor="valueDate" value="Change Value Date" />
                    </div>
                    <TextInput
                      id="valueDate"
                      type="date"
                      value={
                        singleOpex.valueDate
                          ? new Date(singleOpex.valueDate)
                              .toISOString()
                              .split("T")[0]
                          : ""
                      }
                      onChange={(e) =>
                        updateValueDate(
                          singleOpex.id,
                          e.target.value,
                          loadOpEx,
                          setError,
                        )
                      }
                      color="blue"
                    />
                  </div>
                )}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* modal for logout */}
      <Modal
        show={openModalOut}
        size="md"
        popup
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {msg}
            </h3>
            <div className="flex justify-center gap-4">
              <Button color="failure" onClick={() => logOut()}>
                {"OK"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {toastOpen && (
        <CustomToast
          message={toastMessage}
          type="warning"
          duration={3000}
          onClose={() => setToastOpen(false)}
        />
      )}
      </DashboardLayout>
    </>
  );
}

export default Opex;

function toDateInputValue(dateString) {
  if (!dateString) return "";
  return new Date(dateString).toISOString().split("T")[0];
}

function formatDate(dateString) {
  const dateObj = new Date(dateString);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[dateObj.getMonth()];

  const desiredFormat = `${dateObj.getFullYear()}-${month}-${dateObj.getDate()}`;

  return desiredFormat;
}
